/* ==========================================================================
   Valenne Studios — theme.js
   Aucune dépendance externe. Tout est progressif : si JS est désactivé,
   le site reste navigable (liens, formulaires natifs Shopify).
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- Menu */
  function initMenu() {
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      var drawer = document.getElementById(btn.getAttribute('data-menu-toggle'));
      if (!drawer) return;
      btn.addEventListener('click', function () {
        var open = drawer.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ------------------------------------------------- Rail de collections */
  function initRails() {
    document.querySelectorAll('[data-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-rail-track]');
      if (!track) return;
      var items = Array.prototype.slice.call(track.querySelectorAll('.rail__item'));
      if (!items.length) return;

      var index = items.findIndex(function (el) { return el.classList.contains('is-active'); });
      if (index < 0) index = 0;

      function apply(next) {
        index = (next + items.length) % items.length;
        items.forEach(function (el, i) { el.classList.toggle('is-active', i === index); });
        var el = items[index];
        var left = el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
        track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }

      items.forEach(function (el, i) {
        el.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;
          apply(i);
        });
      });

      var prev = rail.querySelector('[data-rail-prev]');
      var next = rail.querySelector('[data-rail-next]');
      if (prev) prev.addEventListener('click', function () { apply(index - 1); });
      if (next) next.addEventListener('click', function () { apply(index + 1); });

      apply(index);
    });
  }

  /* -------------------------------------------------- Galerie produit */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var mains = gallery.querySelectorAll('[data-gallery-main]');

      function show(id) {
        mains.forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-gallery-main') === id);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-gallery-thumb') === id);
        });
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.getAttribute('data-gallery-thumb')); });
      });

      gallery.addEventListener('gallery:select', function (e) {
        if (e.detail && e.detail.mediaId) show(String(e.detail.mediaId));
      });
    });
  }

  /* ----------------------------------------------- Sélecteur de variante */
  function initVariants() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
      var form = root.closest('form') || document.getElementById(root.getAttribute('data-form'));
      var dataEl = document.getElementById(root.getAttribute('data-variants'));
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = document.querySelector('[data-variant-price]');
      var submitEl = document.querySelector('[data-add-to-cart]');
      var skuEl = document.querySelector('[data-variant-sku]');

      function selectedOptions() {
        var out = [];
        root.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          out[parseInt(fieldset.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
        });
        return out;
      }

      function update() {
        var opts = selectedOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });

        if (idInput) idInput.value = match ? match.id : '';

        if (priceEl) {
          if (match) {
            priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
              ? '<s>' + match.compare_at_price_formatted + '</s> ' + match.price_formatted
              : match.price_formatted;
          }
        }

        if (skuEl && match) skuEl.textContent = match.sku || '';

        if (submitEl) {
          var available = match && match.available;
          submitEl.disabled = !available;
          submitEl.textContent = !match
            ? submitEl.getAttribute('data-unavailable-text')
            : available
              ? submitEl.getAttribute('data-default-text')
              : submitEl.getAttribute('data-sold-out-text');
        }

        // Marque les tailles indisponibles pour la couleur choisie
        root.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
          var index = parseInt(fieldset.getAttribute('data-option-index'), 10);
          fieldset.querySelectorAll('label[data-value]').forEach(function (label) {
            var probe = opts.slice();
            probe[index] = label.getAttribute('data-value');
            var found = variants.find(function (v) {
              return v.options.every(function (o, i) { return i === index ? o === probe[i] : (opts[i] == null || o === opts[i]); });
            });
            label.classList.toggle('is-unavailable', !found || !found.available);
          });
        });

        if (match && match.featured_media_id) {
          var gallery = document.querySelector('[data-gallery]');
          if (gallery) {
            gallery.dispatchEvent(new CustomEvent('gallery:select', {
              detail: { mediaId: match.featured_media_id }
            }));
          }
        }

        if (match && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      root.addEventListener('change', update);
      update();
      if (form) { /* garde une référence pour d'éventuelles extensions */ }
    });
  }

  /* ------------------------------------------------------- Quantité */
  function initQuantity() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var min = parseInt(input.getAttribute('min') || '0', 10);
          var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    document.querySelectorAll('[data-cart-form]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[name="updates[]"]')) form.submit();
      });
    });
  }

  /* ------------------------------------- A propos : scroll horizontal */
  function initStory() {
    var story = document.querySelector('[data-story]');
    if (!story) return;
    var track = story.querySelector('[data-story-track]');
    var slides = story.querySelectorAll('.story__slide');
    if (!track || slides.length < 2) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      story.style.height = 'auto';
      story.querySelector('.story__sticky').style.position = 'static';
      story.querySelector('.story__sticky').style.height = 'auto';
      track.style.position = 'static';
      track.style.flexDirection = 'column';
      track.style.width = '100%';
      slides.forEach(function (s) { s.style.flex = '0 0 auto'; s.style.width = '100%'; });
      return;
    }

    var n = slides.length;

    function size() {
      story.style.height = (window.innerHeight * n) + 'px';
      track.style.width = (window.innerWidth * n) + 'px';
      move();
    }

    function move() {
      var vh = window.innerHeight;
      var top = story.offsetTop;
      var scrolled = window.scrollY - top;
      var span = Math.max(1, vh * n - vh);
      var p = Math.max(0, Math.min(1, scrolled / span));
      track.style.transform = 'translateX(' + (-p * window.innerWidth * (n - 1)) + 'px)';

      slides.forEach(function (slide, i) {
        var local = Math.max(-1, Math.min(1, (scrolled - i * vh) / vh));
        slide.querySelectorAll('[data-depth]').forEach(function (img) {
          var depth = parseFloat(img.getAttribute('data-depth')) || 1;
          img.style.transform = 'translateY(' + (local * 26 * depth) + 'px)';
        });
      });
    }

    window.addEventListener('scroll', move, { passive: true });
    window.addEventListener('resize', size);
    size();
  }

  /* ------------------------------------------------------- Init */
  function boot() {
    initMenu();
    initRails();
    initGallery();
    initVariants();
    initQuantity();
    initStory();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init dans l'éditeur de thème Shopify
  document.addEventListener('shopify:section:load', boot);
})();
